import { render, staticRenderFns } from "./AccesoAMoocReports.vue?vue&type=template&id=4d4cd1aa"
import script from "./AccesoAMoocReports.vue?vue&type=script&lang=js"
export * from "./AccesoAMoocReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports